var map = {
	"./brand-SEI.png": 332,
	"./brand-adm.png": 6893,
	"./brand-osa.png": 5351,
	"./brand-pamjaya.jpg": 4063,
	"./brand-sim.png": 1530,
	"./brand-sml.png": 2847,
	"./brand-tmmin.jpg": 8115,
	"./brand-unilever.png": 596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2678;